import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
// import { DeleteExamMethods } from './DeleteExamMethods';
import { FormExamMethodsMicrobiology } from './FormExamMethodsMicrobiology';
import { DeleteExamMethodsMicrobiology } from './DeleteExamMethodsMicrobiology';
// import { FormExamMethods } from './FormExamMethods';

export const ModalExamMethodsMicrobiology = (props) => {

    const {
        modal, toggleModal, method, loadingModal,
        name, code, id_machine_models, id_method, machineModels, selectMachineModels, methods, handleInputChange, validaciones, handleSelectValues,
        saveCreate, saveUpdate, saveDelete
    } = props;

    return (
        <Modal isOpen={modal} toggle={toggleModal} backdrop='static' keyboard={false} centered={true}>
            <ModalHeader toggle={toggleModal}>
                {
                    method === "create" ?
                        "Creación de método"
                        : (method === "update") ?
                            "Actualización de método"
                            : "Eliminar método"
                }
            </ModalHeader>
            {
                method === "create" ?
                    <FormExamMethodsMicrobiology
                        button="Crear nuevo método"
                        {...{ toggleModal, loadingModal, name, code, id_machine_models, id_method, machineModels, selectMachineModels, methods, handleInputChange, handleSelectValues, validaciones, methodAction: saveCreate }}
                    />
                    : (method === "update") ?
                        <FormExamMethodsMicrobiology
                            button="Actualizar método"
                            {...{ toggleModal, loadingModal, name, code, id_machine_models, machineModels, selectMachineModels, handleInputChange, handleSelectValues, validaciones, methodAction: saveUpdate }}
                        />
                        : <DeleteExamMethodsMicrobiology {...{ toggleModal, loadingModal, name, saveDelete }} />
            }
        </Modal>
    )
}
